export default {
    // Builder
    formBuilder:              () => import('./builder/formBuilder'),
    formBuilderList:          () => import('./builder/formBuilderList'),

    // Basic Fields
    inputField:               () => import('./fields/inputField'),
    textArea:                 () => import('./fields/textArea'),
    numberField:              () => import('./fields/numberField'),
    selectField:              () => import('./fields/selectField'),

    // Advanced Fields
    inputGroup:               () => import('./fields/inputGroup'),
    selectBlocks:             () => import('./fields/selectBlocks'),
    addressField:             () => import('./fields/addressField'),
    // fieldImage:               () => import('./fields/fieldImage'),
    dateField:                () => import('./fields/dateField'),
    yearsMonths:              () => import('./fields/yearsMonths'),
    customField:              () => import('./fields/customField'),

    // Layout Fields
    pageColumns:              () => import('./fields/pageColumns'),
    pageBreak:                () => import('./fields/pageBreak'),
    pageTitle:                () => import('./fields/pageTitle'),

}
